export default {
    cognito:{
        "aws_project_region": process.env.VUE_APP_PROJECT_REGION,
        // "aws_cognito_identity_pool_id": process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
        "aws_cognito_region": process.env.VUE_APP_COGNITO_REGION,
        "aws_user_pools_id": process.env.VUE_APP_USER_POOLS_ID,
        "aws_user_pools_web_client_id": process.env.VUE_APP_USER_POOLS_WEB_CLIENT_ID,
        "oauth": {}            
    },
    apiGatewayCmdb: {
        REGION: process.env.VUE_APP_APIG_CMDB_REGION,
        URL: process.env.VUE_APP_APIG_CMDB_URL,
    },
    apiGatewayIPMan: {
        REGION: process.env.VUE_APP_APIG_IPMAN_REGION,
        URL: process.env.VUE_APP_APIG_IPMAN_URL,
    },
    // cognito:{
    //     "aws_project_region": "eu-west-1",
    //     "aws_cognito_identity_pool_id": "eu-west-1:36d1e563-6f2f-4a37-bd89-b3061b8589a0",
    //     "aws_cognito_region": "eu-west-1",
    //     "aws_user_pools_id": "eu-west-1_tq4Ss2Bnf",
    //     "aws_user_pools_web_client_id": "7u2g8sr3t61dicnfs4gv3cl3nn",
    //     "oauth": {}            
    // },
    // apiGatewayCmdb: {
    //     REGION: "eu-west-1",
    //     URL: "https://vbxxv2ecg8.execute-api.eu-west-1.amazonaws.com/dev"
    // },
    // apiGatewayIPMan: {
    //     REGION: "eu-west-1",
    //     URL: "https://yorwdi486f.execute-api.eu-west-1.amazonaws.com/dev"
    // },
    // cognito_prod:{
    //     "aws_project_region": "eu-west-1",
    //     "aws_cognito_identity_pool_id": "eu-west-1:b515a7b1-b33f-43cf-8789-af3929a3030b",
    //     "aws_cognito_region": "eu-west-1",
    //     "aws_user_pools_id": "eu-west-1_2QL30fYhW",
    //     "aws_user_pools_web_client_id": "1up3pqgnj8u7ctlv4ap9nifpjh",
    //     "oauth": {}            
    // },
    // apiGatewayCmdb_prod: {
    //     REGION: "eu-west-1",
    //     URL: "https://vbxxv2ecg8.execute-api.eu-west-1.amazonaws.com/prod"
    // },
    // apiGatewayIPMan_prod: {
    //     REGION: "eu-west-1",
    //     URL: "https://yorwdi486f.execute-api.eu-west-1.amazonaws.com/prod"
    // }
}
